<ng-container *ngIf="form" [formGroup]="form">
  <div class="topbar">
    <h4>Destination Number </h4>
    <div class="right-icons" *ngIf="isShortCodeAllowed() && source !== 'mosearch'">
      <a tooltip="Show and select pre-approved MO Short Codes" (click)="openShortCodeList()"><span class="far fa-bookmark"></span></a>
    </div>
  </div>
  <div class="mb-20 text-template-wrapper">
    <div class="input-group">
      <span class="input-group-btn cp" (click)="onClickAddPlus()" tooltip="Enable to automatically add `+` before the destination number">
        <a class="btn" [ngClass]="isAddPlusEnabled ? 'btn-primary': 'btn-outline-primary'"><i class="icon-add"></i></a>
      </span>
      <input placeholder="Enter the destination number" class="form-control" [(ngModel)]="val" formControlName="number" (ngModelChange)="onChangeSender()"
        (keydown)="onKeydownInput($event)" (blur)="onBlur()" />
    </div>
    <input-errors [control]="form.controls.number" [service]="validationService"></input-errors>
    <a class="icon" [hidden]="icon !== 'save'" (click)="addNumber()"><span class="icon-add"></span></a>
    <a class="icon" [hidden]="icon !== 'loading'"><span class="icon-wait"></span></a>
    <div *ngIf="valid === false">
      <div *ngIf="valCountry === ''" class="help-block m-b-none text-danger">
        Error retrieving country for number {{ this.val }}
      </div>
      <div *ngIf="valCountry !== '' && valCountry !== country" class="help-block m-b-none text-danger">
        Number ({{ val }} {{ valCountry }}) must match the selected country ({{ country }})
      </div>
    </div>
    <ul [hidden]="!numbers.length" class="input-list-items input-list-items-inline">
      <li *ngFor="let number of numbers">
        <span (click)="editNumber(number)">{{ inputListText(number) }}</span>
        <button (click)="removeNumber(number)" class="input-list-remove btn btn-sm" type="button">
          <i class="text-danger fa fa-times" title="Remove"></i>
        </button>
      </li>
    </ul>
  </div>
</ng-container>



<ng-template #moShortCodeModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">MO Short Codes</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-mo-short-code-list [numbers]="numbers" [country]="country" [shortCodeCountries]="shortCodeCountries" (select)="onSelectShortCode($event)"
      (unSelect)="onUnSelectShortCode($event)"></app-mo-short-code-list>
  </div>
  <div class="modal-footer pt-10">
    <button class="btn btn-primary" type="button" (click)="dialogRef.close(true)">Done</button>
  </div>
</ng-template>
